<template>
  <dd-modal
      :destroyOnClose="true"
      @cancel="closeModal"
      :show-cancel="true"
      :visible="showUploadModal"
      data-dusk="upload-modal"
  >
    <dd-card>
      <dd-form @submit="onOk">
        <dd-step title="categorie" v-if="!categorySet">
            <dd-select
                @select="onCategorySelect"
                v-if="attachableCategories.length"
                title="Kies een categorie"
                v-model="activeAttachableCategoryName"
                rules="required"
                data-dusk="attachable-categories"
            >
              <a-select-option
                  v-for="(attachableCategory, idx) in attachableCategories"
                  v-bind:key="attachableCategory.name"
                  :value="attachableCategory.name"
              >
                {{ attachableCategory.name }}
              </a-select-option>
            </dd-select>
        </dd-step>
        <dd-step title="uploaden">
          <h3 style="width: 100%; text-align: center">Bestanden uploaden naar {{activeAttachableCategoryName}}</h3>
          <DocumentUploadComponent
              v-if="activeAttachableCategory && !activeAttachableCategory.template"
              ref="documentUploadComponent"
              :key="activeAttachableCategory.id"
              :attachable-category-id="activeAttachableCategory.id"
              :has-attachable-type="hasAttachableType"
              :has-attachable-id="hasAttachableId"
          />
        </dd-step>
      </dd-form>
    </dd-card>
  </dd-modal>
</template>

<script>
import DocumentUploadComponent from "./DocumentUploadComponent";
import {mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "UploadModal",
  components: {
    DocumentUploadComponent
  },
  props:{
    categorySet: {
      value: Boolean
    }
  },
  computed: {
    ...mapFields(`$_attachable_widget`, {
      activeAttachableCategoryName: 'activeAttachableCategoryName',
    }),
    ...mapGetters('$_attachable_widget', {
      activeAttachableCategory: 'activeAttachableCategory',
    }),
    ...mapState(`$_attachable_widget`, {
      showUploadModal: 'showUploadModal',
      attachableCategories: 'attachableCategories',
      hasAttachableType: 'hasAttachableType',
      hasAttachableId: 'hasAttachableId',
    }),
  },
  methods: {
    onCategorySelect() {
      if (this.activeAttachableCategory.template) {
        this.createCategoryFromTemplate(this.activeAttachableCategory);
      } else {
        this.setShowUploadModal(true);
      }
    },
    ...mapActions(`$_attachable_widget`, {
      createCategoryFromTemplate: 'createCategoryFromTemplate',
      getAttachables: 'getAttachables',
  }),
    ...mapMutations(`$_attachable_widget`, {
      setShowUploadModal: 'SET_SHOW_UPLOAD_MODAL',
    }),
    onCancel() {
      this.closeModal();
    },
    closeModal() {
      this.$emit('close', this.activeAttachableCategory);
      this.setShowUploadModal(false);
    },
    onOk() {
      this.closeModal();
      this.getAttachables();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

</style>
